var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4613 18.4161L7.58307 18.4161L7.58307 15.1661M6.61088 16.1383L18.8616 3.88753C19.7078 3.04139 21.0796 3.0414 21.9258 3.88753C22.7719 4.73367 22.7719 6.10553 21.9258 6.95166L9.49433 19.3831C8.91361 19.9638 8.62324 20.2542 8.3018 20.5038C8.01628 20.7256 7.71276 20.9231 7.3944 21.0944C7.03598 21.2872 6.65291 21.4351 5.88678 21.731L3.25 22.7492L4.09838 20.2037C4.38792 19.335 4.5327 18.9007 4.73405 18.4951C4.91288 18.1349 5.12475 17.7921 5.36693 17.471C5.63964 17.1095 5.96339 16.7858 6.61088 16.1383Z",
    stroke: "#4B4B4B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.d23e4f7e3a0e31c8accf45360fcc38ae.svg";
export { ForwardRef as ReactComponent };